import React, { Component } from 'react'
import Input from 'components/Form/Input'
import styled from 'styled-components/macro'

export const vehicles = [
  {
    name: 'Two Door / Sedan',
    value: 'two_door',
  }, {
    name: 'Hatchback / SUV',
    value: 'hatchback_suv',
  }, {
    name: 'Minivan / Passenger Van',
    value: 'van',
  }, {
    name: 'Pickup Truck',
    value: 'pickup_truck',
  }, {
    name: 'Cargo Van',
    value: 'cargo_van',
  }, {
    name: 'Box Truck (10 - 15 ft)',
    value: 'box_truck',
  }, {
    name: 'Box Truck (16 - 25 ft)',
    value: 'large_box_truck',
  }, {
    name: 'Box Truck (26+ ft)',
    value: 'oversized_box_truck',
  }
]

export function getVehicleLabel(kind) {
  const vehicle = vehicles.find(({ value }) => value === kind)
  return vehicle ? vehicle.name : ''
}

export const vehicleColors = [
  'beige',
  'blue',
  'black',
  'brown',
  'grey',
  'green',
  'orange',
  'pink',
  'purple',
  'red',
  'white',
  'yellow',
]

const CapsSelect = styled(Input.Select)`
  text-transform: capitalize;
`

export class VehicleTypeSelect extends Component {
  render() {
    return(
      <Input.Select
        {...this.props}>
        {vehicles.map(v => (
          <option key={v.value} value={v.value}>{v.name}</option>
        ))}
      </Input.Select>
    )
  }
}

export class VehicleColorSelect extends Component {
  render() {
    return(
      <CapsSelect
        {...this.props}>
        {vehicleColors.map(color => <option key={color} value={color}>{color}</option>)}
      </CapsSelect>
    )
  }
}